module.exports = __webpack_public_path__ + "static/dev-2c69d2fa7aa28d82e81fbc983a4620a6.svg";